import { Box, Icon, Image, Text } from '@zillow/constellation-10';
import { IconUserFilled } from '@zillow/constellation-icons';

type Props = {
  firstName?: string;
  lastName?: string;
  userName?: string;
  email?: string;
  profileImageUrl?: string;
};

const UserIcon = ({ firstName, lastName, userName, email, profileImageUrl }: Props) => {
  let displayName = '';
  if (firstName && lastName) {
    displayName = `${firstName} ${lastName}`;
  } else if (firstName) {
    displayName = firstName;
  } else if (userName) {
    displayName = userName;
  } else if (email) {
    displayName = email;
  }
  return (
    <>
      <Box
        css={{
          alignItems: 'center',
          backgroundColor: 'bg.accent.aqua.hero',
          borderRadius: 'ellipse',
          color: 'text.onImpact.neutral',
          display: { base: 'none', lg: 'flex' },
          height: '800',
          justifyContent: 'center',
          width: '800',
          overflow: 'hidden',
        }}
      >
        {profileImageUrl ? (
          <Image src={profileImageUrl} css={{ borderRadius: 'ellipse' }} />
        ) : (
          <Icon render={<IconUserFilled />} size="sm" css={{ position: 'relative', top: '-25' }} />
        )}
      </Box>
      <Text css={{ display: { lg: 'none' } }}>{displayName}</Text>
    </>
  );
};

export default UserIcon;
